Element.implement({
    hasEvent: function(eventType,fn) {
        var myEvents = this.retrieve('events');
        return myEvents && myEvents[eventType] && (fn == undefined || myEvents[eventType].keys.contains(fn));
    }
});